module.exports = __webpack_public_path__ + "img/kr-product-intl-card4-img2.87a4333.png";